import { render, staticRenderFns } from "./muokkaa-suoritetta.vue?vue&type=template&id=0adb5085&scoped=true&"
import script from "./muokkaa-suoritetta.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-suoritetta.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-suoritetta.vue?vue&type=style&index=0&id=0adb5085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adb5085",
  null
  
)

export default component.exports